import type { Stripe, StripeElements, StripeElementsOptions } from "@stripe/stripe-js";
import type { PublicInvoiceDetails } from "@/data/invoice";

/** Match createPaymentIntentForInvoice's customer/save-card policy. */
export function invoiceIntentOptions(invoice: PublicInvoiceDetails): StripeElementsOptions {
  return {
    mode: "payment",
    amount: Math.max(1, invoice.invoice.amountDue),
    currency: invoice.invoice.currency.toLowerCase(),
    // The backend saves the card only when the invoice itself owns an email.
    // Guest-entered email alone must not enable saving a card to a customer.
    setupFutureUsage: invoice.customer.email ? "off_session" : undefined,
  };
}

export function confirmInvoicePayment({
  stripe,
  elements,
  clientSecret,
  email,
  returnUrl,
}: {
  stripe: Stripe;
  elements: StripeElements;
  clientSecret: string;
  email: string;
  returnUrl: string;
}) {
  const billingEmail = email.trim();
  return stripe.confirmPayment({
    elements,
    clientSecret,
    confirmParams: {
      return_url: returnUrl,
      receipt_email: billingEmail,
      // InvoiceSheet hides Stripe's email field because our form collects it.
      // receipt_email does NOT satisfy that missing billing_details field.
      payment_method_data: { billing_details: { email: billingEmail } },
    },
    redirect: "if_required",
  });
}
